import { combineReducers } from 'redux';
import BulkPricingFacetPanelReducer from './BulkPricingFacetPanel/BulkPricingFacetPanelReducer';
import SurveyLibraryReducer from './BulkPricingSurveyGridCreate';
import { PAGE_CODE } from '../../../lib/pageCodeDefaults';

const defaultState = {
    pageCode: PAGE_CODE.BULK_PRICING_SURVEY_SEARCH
};

export function BulkPricingReducer (state = defaultState, action) {
    switch (action.type) {
        case 'SOME_THANG':
            return {
                ...state,
                foo: 'bar'
            };

        default: return state;
    }
}

export default combineReducers({
    SurveyLibrary: SurveyLibraryReducer,
    FacetPanel: BulkPricingFacetPanelReducer,
    BulkPricing: BulkPricingReducer,
})
